export default __webpack_public_path__ + "static/media/plura4.10449aca.png";